"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CourseRegistration = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.CourseRegistration = {
  name: 'CourseRegistration',
  table: {
    fieldNames: ["course", "requestDate", "approveDate"]
  },
  autoRoutes: ['create', 'update'],
  card: {},
  form: {
    bufferAtEnd: 300,
    modal: {
      maxWidth: '700px'
    },
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      course: {
        type: 'linked',
        entityTypeName: 'Course',
        description: "Which {{COURSE}} is this registration for?"
      },
      requestDate: {
        type: 'datetime',
        description: "When the registration request made?"
      },
      approveDate: {
        type: 'datetime',
        description: "When was the registration request approved? Note: providing this date implies participation in the {{COURSE}}."
      },
      revokeDate: {
        type: 'datetime',
        description: "When was the registration request revoked (if applicable)?"
      },
      certifyDate: {
        type: 'datetime',
        description: "When was the person certified in this course (if applicable)?"
      },
      description: {
        type: 'longText',
        description: "Add a description or any notes about this {{COURSE_REGISTRATION}}."
      }
    })
  }
};